import { useEffect, useState } from 'react';
import { type OpenSidePanelsParams } from '@alfa-bank/newclick-types/open-side-panel-params';

type Props = {
    open: boolean;
    sidePanelParams?: OpenSidePanelsParams;
};

/**
 * Хранит историю открытия сайд панелей, которые были открыты в контексте других сайдпанелей (open === true при открытии).
 * @return {OpenSidePanelsParams} getPreviousSidePanel - возвращает параметры предыдущей сайд панели, удаляет текущую из стека.
 */
export const useSidePanelsStack = ({ open, sidePanelParams }: Props) => {
    const [sidePanelStack, setSidePanelStack] = useState<OpenSidePanelsParams[]>([]);

    useEffect(() => {
        if (!open || !sidePanelParams) {
            return;
        }

        setSidePanelStack((previousSidePanelStack) => {
            if (sidePanelParams !== previousSidePanelStack[0] && JSON.stringify(sidePanelParams) !== JSON.stringify(previousSidePanelStack[0])) {
                return [sidePanelParams, ...previousSidePanelStack];
            }

            return previousSidePanelStack;
        });
    }, [open, sidePanelParams]);

    const getPreviousSidePanel = () => {
        if (sidePanelStack.length < 2) {
            return null;
        }

        let previousSidePanelParams!: OpenSidePanelsParams;

        setSidePanelStack((previousSidePanelStack) => {
            const updatedStack = [...previousSidePanelStack];

            if (
                sidePanelParams?.sidePanelId === previousSidePanelStack[1].sidePanelId &&
                previousSidePanelStack.length > 2
            ) {
                previousSidePanelParams = previousSidePanelStack['2'];
                updatedStack.splice(0, 2); // Елси 2 удаляем
            } else {
                previousSidePanelParams = previousSidePanelStack['1'];
                updatedStack.splice(0, 1); // Если 1
            }

            return [...previousSidePanelStack].slice(1);
        });

        return previousSidePanelParams;
    };

    const previousSidePanelExists = !!sidePanelStack[1];

    return {
        sidePanelStack,
        previousSidePanelExists,
        getPreviousSidePanel,
    };
};
